
import React from "react";
import { BarChart2, Image } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";

interface AdminButtonProps {
  isAdmin: boolean;
}

const AdminButton: React.FC<AdminButtonProps> = ({ isAdmin }) => {
  const navigate = useNavigate();
  
  if (!isAdmin) {
    return null;
  }
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="rounded-full p-1 hover:bg-clustr-overlay"
        >
          <BarChart2 className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => navigate("/admin/analytics")}>
          <BarChart2 className="h-4 w-4 mr-2" />
          Analytics Dashboard
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/admin/thumbnail-migration")}>
          <Image className="h-4 w-4 mr-2" />
          Thumbnail Migration & Cleanup
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AdminButton;
